<template>
  <div>
    <div v-if="phase" style="font-size: 13px; position: relative">
      <img
        v-if="phase.badge === 'harvest'"
        src="./harvest.png"
        alt=""
        style="position: absolute; top: -4px; right: 0; width: 50px"
      />
      <img
        v-if="phase.badge === 'plant'"
        src="./plant.png"
        alt=""
        style="position: absolute; top: -8px; right: 0; width: 50px"
      />
      <span style="line-height: 28px">{{ phase.index }} {{ phase.name }}</span>
      <div
        class="work"
        style="position: absolute; top: 0; left: 0"
      >
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LaborPlan',
  props: {
    phase: {
      type: Object,
      required: false,
    },
  },
  mounted() {
    console.log(this.phase)
  },
  methods:{

  }
}
</script>



// WEBPACK FOOTER //
// src/components/product/plan/PlanDetailCalendarCell.vue